export enum FieldGroupTypeEnum {
	'normal' = 'normal',
	'visual' = 'visual',
	'complex' = 'complex',
	'widget' = 'widget',
	'drawing' = 'drawing'
}
